import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, DropdownButton, Form, Col, Row, Nav, OverlayTrigger, Tooltip, ButtonGroup, ToastContainer, Spinner } from 'react-bootstrap';

import { ArticleService } from '../../services/ArticleService';
import { ReglementService } from '../../services/ReglementService';
import { EditionService } from '../../services/EditionService';

import DynamicTable from '../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../components/pagination/Pagination';
import SideDetails from '../../components/side-details/SideDetails';
import ReglementDetails from '../../components/side-details/reglement/reglement-details/ReglementDetails';
import ReglementEdition from '../../components/side-details/reglement/reglement-edition/ReglementEdition';
import ColManager from '../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../components/families/Families';
import './Reglements.scss';
import { PreferenceService } from '../../services/PreferenceService';
import ConfirmDialog from '../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../components/error-manager/ErrorManager";
import SendMailDialog from "../../components/send-mail-dialog/SendMailDialog";
import { GlobalContext } from "../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, formattedDateInput, currencyFormat, getFile } from '../../helper/Helper'
import TagsFilter from "../../components/tags-filter/TagsFilter";


const Reglements = () => {

  const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

  let reglementsParams = useRef({
    'start': 0,
    'limit': null,
    'search': null,
    'filters': {},
    'sort': null,
    'order': null,
    'filtre': null,
    'resume': true
  });

  const [globalError, setGlobalError] = useState()
  const [searchParams, setSearchParams] = useSearchParams();
  const [isGetReglementsLoading, setIsGetReglementsLoading] = useState()
  const [reglements, setReglements] = useState()
  const [resumeCategories, setResumeCategories] = useState()
  const [isPDFLoading, setIsPDFLoading] = useState()
  const [sideWidth, setSideWidth] = useState()
  const [tableHeaders, setTableHeaders] = useState()
  const [checkedElementIdList, setCheckedElementIdList] = useState([])
  const [currentPagination, setCurrentPagination] = useState(1)
  const [isTableFilterVisible, setIsTableFilterVisible] = useState(false)
  const [confirmDialog, setConfirmDialog] = useState({ show: false, dialogInfos: null })
  const [currentReglement, setCurrentReglement] = useState()
  const [isReglementEditing, setIsReglementEditing] = useState(false)
  const [reglementEditingId, setReglementEditingId] = useState()
  const [sendMailDialog, setSendMailDialog] = useState({})

  let searchRef = useRef(null);

  const [tableRowElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF" },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail" }
  ])

  const [reglementElementActions] = useState([
    { icon: "print", title: "Imprimer", action: "downloadPDF" },
    { icon: "email", title: "Envoyer par mail", action: "sendEmail" }
  ])

  /*   useEffect(() => {
      if (grants) {
        !grants.reglements.valeur && setGlobalError({ statusText: `Reglements : vous n'avez pas les droit d'accès à cette ressource.` })
      }
    }, [grants]); */

  useEffect(() => {
    if (globalContextLoaded) {
      searchParams.get('reglementId') && getReglement(searchParams.get('reglementId'))
      setPreferences()
      getReglements()
    }
  }, [globalContextLoaded]);

  function setPreferences() {
    setTableHeaders(formatTableHeadersFromPrefs(preferences.reglements['tableHeaders'], parametres.reglements['fieldsLabel']))
    reglementsParams.current['sort'] = preferences.reglements['tableSort']
    reglementsParams.current['order'] = preferences.reglements['tableOrder']
    reglementsParams.current['limit'] = preferences.reglements['tableCount'] || 5
    reglementsParams.current['fields'] = Object.keys(preferences.reglements['tableHeaders']).join(',')
  }

  function getDayTitle(place) {
    let dateRef = reglementsParams.current?.filters['filter[date_valeur]']?.find(f => f.operation == "equal_to")?.value ? new Date(reglementsParams.current?.filters['filter[date_valeur]']?.find(f => f.operation == "equal_to")?.value + "T00:00:00") : new Date()
    var newDate = new Date(dateRef.getTime())
    newDate.setDate(dateRef.getDate() + place);
    var days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
    var dayName = days[newDate.getDay()];
    return `${dayName} ${newDate.getDate()}`
  }

  function getReglement(reglementId) {
    ReglementService.getReglement(folderDetails?.dossier?._id, reglementId).then(res => {
      if (res.status == 204) {
        setGlobalError({ statusText: "Le règlement demandé n'a pas été trouvé" })
      } else if (!res.data?.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        changeCurrentReglement(res.data.data)
        setIsReglementEditing(false)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function getReglements() {
    setCheckedElementIdList([])
    if (granted(grants, "reglements.consult")) {
      setIsGetReglementsLoading(true)

      if (!reglementsParams.current['filtre']) {
        ReglementService.getReglements(folderDetails?.dossier?._id, reglementsParams.current).then(res => {
          if (!res?.data?.data?.reglements) {
            setReglements()
            setIsGetReglementsLoading(false)
          } else {
            if (!resumeCategories) {
              setResumeCategories(Object.keys(res?.data?.data?.resume).filter(r => res?.data?.data?.resume[r]?.libelle).sort((a, b) => a > b ? 1 : -1))
            }
            setReglements({
              reglements: res.data.data.reglements,
              count: res.data.data.resume.total_count,
              total: res.data.data.resume.total_montant,
              resume: res.data.data.resume
            })
            setIsGetReglementsLoading(false)
          }
        }).catch(error => {
          setGlobalError(error)
          setIsGetReglementsLoading(false)
        });
      } else {
        ReglementService.getReglementsSummary(folderDetails?.dossier?._id, reglementsParams.current).then(res => {
          if (res.status == 204) {
            setReglements({
              reglements: null,
              total: 0,
              count: 0,
              resume: null
            })
            setIsGetReglementsLoading(false)
          } else if (!res?.data?.data[reglementsParams?.current['filtre']]) {
            setReglements({
              reglements: null,
              total: 0,
              count: 0,
              resume: res?.data?.data?.resume
            })
            setIsGetReglementsLoading(false)
          } else {
            setReglements({
              reglements: res.data.data[reglementsParams.current['filtre']].length > 0 ? res.data.data[reglementsParams.current['filtre']] : null,
              total: res.data.data.resume[reglementsParams.current['filtre']].total,
              count: res.data.data.resume[reglementsParams.current['filtre']].count,
              resume: res.data.data.resume
            })
            setIsGetReglementsLoading(false)
          }

        }).catch(error => {
          setGlobalError(error)
          setIsGetReglementsLoading(false)
        });
      }
    }
  }

  function downloadPDF(reglement) {
    EditionService.getReglement(folderDetails?.dossier?._id, reglement._id, "pdf").then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(async (error) => {
      if (
        error.request.responseType === 'blob' &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf('json') != -1
      ) {
        setGlobalError({ response: JSON.parse(await error.response.data.text()) })
      } else {
        setGlobalError(error)
      }
    });
  }

  function sendEmail(reglement, source) {

    // Si envoie mail à partir d'un reglement unique'
    if (reglement) {
      let params = {
        filter: {
          _id: "=" + reglement._id
        }
      }
      setSendMailDialog({
        "clientIdList": [reglement.client_id],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "reglements",
        "params": params,
        "totalElements": 1,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des filtres
    if (source == "filters") {

      let params = {
        filters: reglementsParams.current.filters,
        search: reglementsParams.current.search,
        filter: {},
        filtre: reglementsParams.current.filtre
      }

      if (reglements?.resume?.total_count == 1) {
        params['filter']['_id'] = "=" + reglements?.reglements[0]._id
      }

      // s'il y a un filtre
      let count = reglements?.resume?.total_count
      let editionUrl = "reglements"
      if (reglementsParams.current.filtre) {
        editionUrl = "reglements/summary"
        count = reglements.resume[reglementsParams.current.filtre].count
      }

      setSendMailDialog({
        "clientIdList": reglements?.resume?.total_count == 1 ? [reglements?.reglements[0].client_id] : null,
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": editionUrl,
        "params": params,
        "totalElements": count,
        "show": true
      })
      return
    }

    // Si envoie mail à partir des éléments sélectionnés
    if (source == "checked") {
      let params = {
        filter: {
          _id: "=" + checkedElementIdList.join(',')
        }
      }

      let reglementClientIdList = reglements?.reglements.filter(f => checkedElementIdList.includes(f._id)).map(f => f.client_id)

      setSendMailDialog({
        "clientIdList": [reglementClientIdList],
        "folderId": folderDetails?.dossier?._id,
        "editionUrl": "reglements",
        "params": params,
        "totalElements": checkedElementIdList.length,
        "show": true
      })
      return
    }
  }

  function downloadCheckedReglements() {

    let params = {}
    if (checkedElementIdList?.length > 0) {
      params["filter"] = {}
      params["filter"]["_id"] = "=" + checkedElementIdList.join(',')
    }

    EditionService.getReglements(folderDetails?.dossier?._id, params).then(res => {
      if (!res.data) {
        setGlobalError({ statusText: res.statusText })
      } else {
        getFile(res)
      }
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function getReglementsPDF(idList) {
    if (granted(grants, "reglements.consult")) {
      !idList && setIsPDFLoading(true)
      let params = {
        'start': 0,
        'search': reglementsParams.current.search,
        'sort': reglementsParams.current.sort,
        'order': reglementsParams.current.order,
        'filters': reglementsParams.current.filters
      }

      if (idList) {
        params['reglements'] = idList
      }

      EditionService.getListe(folderDetails?.dossier?._id, params, "reglements", "pdf").then(res => {
        setIsPDFLoading(false)
        if (!res?.data) {
          setGlobalError({ statusText: res.statusText })
        } else {
          getFile(res)
        }
      }).catch(error => {
        setIsPDFLoading(false)
        setGlobalError(error)
      });
    }
  }

  function uncheckElementList(idList) {
    let checkedElementIdListCopy = [...checkedElementIdList];
    idList.map(id => {
      let index = checkedElementIdListCopy.indexOf(id)
      if (index >= 0) {
        checkedElementIdListCopy.splice(index, 1)
      }
    })
    setCheckedElementIdList(checkedElementIdListCopy)
  }



  function saveTableHeadersPrefs(e) {
    const newHeadersObject = {}
    e.forEach(object => {
      newHeadersObject[object['dataTarget']] = { position: object['position'], hidden: object['hidden'] }
    });
    updatePreference({ ["tableHeaders"]: newHeadersObject })
  }

  function updatePreference(prefs) {
    PreferenceService.updatePreferences(folderDetails?.dossier?._id, { prefs: { ['reglements']: prefs } }).then(res => {
      getPreferences()
    }).catch(error => {
      setGlobalError(error)
    });
  }

  function changeCurrentReglement(reglement) {
    reglement?._id ? setSearchParams({ reglementId: reglement._id }) : setSearchParams(searchParams.delete('reglementId'))
    setCurrentReglement(reglement)
  }

  function changeTableHeaders(e) {
    setTableHeaders(e)
    saveTableHeadersPrefs(e)
  }

  function changePagination(p) {
    setCurrentPagination(p)
    reglementsParams.current['start'] = (reglementsParams.current.limit * p) - reglementsParams.current.limit
    getReglements()
  }

  function changeLimit(l) {
    reglementsParams.current['limit'] = l
    updatePreference({ ["tableCount"]: l })
    changePagination(1)
  }

  let searchTimeOut;
  function changeSearchValue(value) {
    window.clearTimeout(searchTimeOut);
    searchTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      reglementsParams.current['start'] = 0
      reglementsParams.current['search'] = value ? value : ""
      searchRef.current.value = value ? value : ""
      getReglements()
    }, 1000);
  }

  let filtersTimeOut;
  function changeFilters(f) {
    window.clearTimeout(filtersTimeOut);
    filtersTimeOut = window.setTimeout(function () {
      setCurrentPagination(1)
      reglementsParams.current['start'] = 0
      reglementsParams.current['filters'] = f ? f : {}
      getReglements()
    }, 1000);
  }

  function clearFilters() {
    setCurrentPagination(1)
    reglementsParams.current['start'] = 0
    reglementsParams.current['filters'] = {}
    getReglements()
    setIsTableFilterVisible(false)
  }

  function changeTagIdList(tagIdList) {
    let filtersCopy = { ...reglementsParams?.current['filters'] }
    if (tagIdList.length > 0) {

      let tagArray = []
      tagIdList.map(tagId => {
        tagArray.push(tagId)
      })

      if (!filtersCopy[`filter[client.tags._id]`]) {
        filtersCopy[`filter[client.tags._id]`] = []
      }

      filtersCopy[`filter[client.tags._id]`] = [
        {
          "operation": "equal_to",
          "operator": "=",
          "value": tagArray.toString()
        }
      ]
      changeFilters(filtersCopy)
      setIsTableFilterVisible(true)
    } else {
      if (filtersCopy && filtersCopy[`filter[client.tags._id]`]) {
        delete filtersCopy[`filter[client.tags._id]`]
        changeFilters(filtersCopy)
      }
    }
  }

  function changeSortOrder(s, o) {
    reglementsParams.current['sort'] = s
    reglementsParams.current['order'] = o
    updatePreference({ ["tableSort"]: s, ["tableOrder"]: o })
    getReglements()
  }

  function onReglementSaved(articleId) {
    getReglement(articleId)
    getReglements()
  }

  function closeSide() {
    setIsReglementEditing(false)
    setCurrentReglement()
  }

  function cancelEdition() {
    setIsReglementEditing(false)
    !currentReglement && setSideWidth()
  }

  function createNewReglement() {
    setIsReglementEditing(true)
    setReglementEditingId()
  }

  function addFilterDate(value) {
    let showDate = reglementsParams.current?.filters['filter[date_valeur]']?.find(f => f.operation == "equal_to")?.value ? new Date(reglementsParams.current?.filters['filter[date_valeur]']?.find(f => f.operation == "equal_to")?.value + 'T12:12:00') : new Date()
    if (value == "today") {
      showDate = new Date()
    }
    if (value == "next") {
      showDate.setDate(showDate.getDate() + 1)
    }
    if (value == "prev") {
      showDate.setDate(showDate.getDate() - 1)
    }
    setIsTableFilterVisible(true)
    if (reglementsParams.current.filters) {
      reglementsParams.current.filters['filter[date_valeur]'] = [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }]
    } else {
      reglementsParams.current.filters = { 'filter[date_valeur]': [{ "operation": "equal_to", "operator": "=", "value": formattedDateInput(showDate) }] }
    }
    let tableHeadersCopy = [...tableHeaders];
    tableHeadersCopy.find(t => t.dataTarget == "date_valeur").hidden = false
    setTableHeaders(tableHeadersCopy);
    setCurrentPagination(1)
    reglementsParams.current['start'] = 0
    getReglements()
  }

  function addFilterInProgress(e) {

    if (e.target.checked) {
      setIsTableFilterVisible(true)
      if (reglementsParams.current.filters) {
        reglementsParams.current.filters['filter[comptabilisee]'] = [{ "operation": "equal_to", "operator": "=", "value": 'false' }]
      } else {
        reglementsParams.current.filters = { 'filter[comptabilisee]': [{ "operation": "equal_to", "operator": "=", "value": 'false' }] }
      }
    } else {
      delete reglementsParams.current.filters['filter[comptabilisee]']
    }

    let tableHeadersCopy = [...tableHeaders];
    tableHeadersCopy.find(t => t.dataTarget == "comptabilisee").hidden = false
    setTableHeaders(tableHeadersCopy);

    setCurrentPagination(1)
    reglementsParams.current['start'] = 0
    getReglements()

  }

  function changeParamFiltre(value) {
    reglementsParams.current['filtre'] = value
    setCurrentPagination(1)
    reglementsParams.current['start'] = 0
    getReglements()
  }

  return (
    <Container fluid id="Reglements" className="py-4">

      <div className="pb-2 d-flex align-items-center justify-content-between">
        <h4 className="m-0">Règlements</h4>
        {granted(grants, "reglements.edit") &&
          <Button variant="primary" onClick={() => createNewReglement()}>Créer un règlement</Button>
        }
      </div>

      <ErrorManager error={globalError} fixed="true" />

      <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />

      <ConfirmDialog
        show={confirmDialog.show}
        dialogInfos={confirmDialog.dialogInfos}
        setCancel={() => setConfirmDialog({ show: false })}
        setConfirm={(a, e) => eval(a)(e)}
      />

      <Row>

        <Col xs="12">
          {granted(grants, "reglements.consult") ?
            <>
              <Row className="mb-4 gx-2">
                <Col sm="12" lg="3" className="mb-2">
                  <InputGroup className="w-auto">
                    <i className="material-icons input-icon text-gray-400">search</i>
                    <FormControl
                      className="input-icon-space rounded-start"
                      placeholder="Recherche globale"
                      type="text"
                      onChange={e => changeSearchValue(e.target.value)}
                      ref={searchRef}
                    />
                    {reglementsParams.current['search'] &&
                      <Button onClick={() => changeSearchValue()} variant="gray-100" className="border border-start-0">
                        <i className="material-icons i-lg">clear</i>
                      </Button>
                    }
                  </InputGroup>
                </Col>
                <Col sm="12" lg="auto" className="mb-2 d-flex align-items-center">
                  <InputGroup className="me-2 w-auto">
                    <TagsFilter btnClassName="rounded-end-0" btnTitle="Filtrer par tags client" documentType="clients" changeTagIdList={tagIdList => changeTagIdList(tagIdList)} parentFilters={reglementsParams?.current['filters']} />
                    {Object.keys(reglementsParams.current.filters).length == 0 &&
                      <OverlayTrigger placement="right" delay={{ show: 800 }} overlay={<Tooltip>Filtres de recherche</Tooltip>}>
                        <Button variant="secondary" onClick={() => setIsTableFilterVisible(!isTableFilterVisible)}>
                          <i className="material-icons i-lg">filter_alt</i>
                        </Button>
                      </OverlayTrigger>
                    }
                    {Object.keys(reglementsParams.current.filters).length != 0 &&
                      <Button className="d-flex" variant="warning" onClick={() => clearFilters()}>
                        Suppr. les filtres
                        <i className="material-icons i-lg ms-2 d-inline-flex">clear</i>
                      </Button>
                    }
                  </InputGroup>
                  <ColManager tableHeaders={tableHeaders} changeTableHeaders={e => changeTableHeaders(e)} />
                  <ButtonGroup className="me-3">
                    <Button variant="secondary" onClick={() => addFilterDate("prev")}>
                      {getDayTitle(-1)}
                      <i className="material-icons float-start me-1">
                        arrow_back_ios_new
                      </i>
                    </Button>
                    <Button onClick={() => addFilterDate("today")} variant={reglementsParams.current?.filters && reglementsParams.current?.filters['filter[date_valeur]']?.find(f => f.operation == "equal_to")?.value == formattedDateInput(new Date()) ? "primary-200" : "secondary"} >Règlements du jour</Button>
                    <Button variant="secondary" onClick={() => addFilterDate("next")}>
                      {getDayTitle(1)}
                      <i className="material-icons float-end ms-1">
                        arrow_forward_ios
                      </i>
                    </Button>
                  </ButtonGroup>
                </Col>
                <Col sm="12" lg="auto" className="mb-2 d-flex align-items-center">
                  <Form.Check
                    className="me-3"
                    label="Paiements en cours uniquement"
                    type="switch"
                    onChange={e => addFilterInProgress(e)}
                    checked={reglementsParams.current?.filters && reglementsParams.current?.filters['filter[comptabilisee]']?.find(f => f.operation == "equal_to")?.value == 'false'}
                  />

                  {reglements?.count > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="secondary" id="dropdown-selectionnes">
                        {reglements?.count} Résultat{reglements?.count > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getReglementsPDF()}>Imprimer la liste</Dropdown.Item>
                        {/* <Dropdown.Item onClick={() => getreglementsPDF()}>Imprimer les factures</Dropdown.Item> */}
                        <Dropdown.Item onClick={() => sendEmail(null, "filters")}>Envoyer les reglements par mail</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  }

                  {checkedElementIdList?.length > 0 &&
                    <Dropdown className="d-inline-block me-2">
                      <Dropdown.Toggle variant="dark" id="dropdown-selectionnes">
                        {checkedElementIdList.length} Sélectionné{checkedElementIdList?.length > 1 && <span>s</span>}
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => getReglementsPDF(checkedElementIdList)}>Imprimer la liste</Dropdown.Item>
                        <Dropdown.Item onClick={() => downloadCheckedReglements()}>Imprimer les règlements</Dropdown.Item>
                        <Dropdown.Item onClick={() => sendEmail(null, "checked")}>Envoyer les reglements par mail</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  }

                </Col>

              </Row>
              {granted(grants, "reglements.consult.totaux") &&
                <Row className="mb-3">
                  <Col>
                    <Nav variant="pills" activeKey={reglementsParams.current.filtre || "all"} >
                      <Nav.Item>
                        <Nav.Link onClick={() => changeParamFiltre()} eventKey="all" className="border d-flex flex-column me-2 h-100">
                          <span className="fw-bold">Tous ({reglements?.resume?.total_count || 0})</span>
                          <span className="">
                            Total : {currencyFormat(reglements?.resume?.total_montant || 0)}
                          </span>

                        </Nav.Link>
                      </Nav.Item>
                      {resumeCategories && resumeCategories.map(category => (
                        <Nav.Item key={category}>
                          <Nav.Link onClick={() => changeParamFiltre(category)} eventKey={category} className="border d-flex flex-column me-2 h-100">
                            <span className="fw-bold">{category} ({(reglements?.resume && reglements?.resume[category]?.count) ? reglements?.resume[category]?.count : 0})</span>
                            <span className="">
                              Total : {currencyFormat((reglements?.resume && reglements?.resume[category]?.montant) ? reglements?.resume[category]?.montant : 0)}
                            </span>
                          </Nav.Link>
                        </Nav.Item>
                      ))}
                    </Nav>
                  </Col>
                </Row>
              }
              <Row className="mt-3">
                <Col xs="12">
                  <div className="bg-white rounded border">
                    <DynamicTable
                      isDataLoading={isGetReglementsLoading}
                      elementActions={tableRowElementActions}
                      setElementAction={(a, e) => eval(a)(e)}
                      sideWidth={sideWidth}
                      tableHeaders={tableHeaders}
                      tableDataList={reglements?.reglements}
                      currentElement={currentReglement}
                      changeCurrentElement={e => changeCurrentReglement(e)}
                      checkedElementIdList={checkedElementIdList}
                      setCheckedElementIdList={e => setCheckedElementIdList(e)}
                      changeFilters={f => changeFilters(f)}
                      isTableFilterVisible={isTableFilterVisible}
                      changeSortOrder={(s, o) => changeSortOrder(s, o)}
                      params={reglementsParams.current}
                    />
                    <Pagination className="m-3" itemsLength={reglements?.count} elementsPerPage={reglementsParams.current.limit} currentPagination={currentPagination} changePagination={p => changePagination(p)} showChangeLimit showDefinePage changeLimit={l => changeLimit(l)} />
                  </div>
                </Col>
              </Row>
            </>
            :
            <Row>
              <Col>
                <em className="py-1 px-2 bg-gray-100 rounded mt-2">- Vous n'avez pas les droits d'accès à cette ressource -</em>
              </Col>
            </Row>
          }

          {(currentReglement || isReglementEditing) &&
            <SideDetails
              editMode={isReglementEditing}
              currentElement={isReglementEditing ? null : { id: currentReglement?._id, label: new Date(currentReglement?.date).toLocaleString(), title: currentReglement?.client_nom }}
              changeCurrentElement={e => changeCurrentReglement(e)}
              setSideClose={closeSide}
              setSideCancel={cancelEdition}
              setSideWidth={e => setSideWidth(e)}
              detailsComponent={
                isReglementEditing ?
                  <ReglementEdition folderId={folderDetails?.dossier?._id} reglementEditingId={reglementEditingId} onSetSaved={f => onReglementSaved(f)} />
                  :
                  <>
                    {granted(grants, "reglements.consult") &&
                      <ReglementDetails folderId={folderDetails?.dossier?._id} reglementId={currentReglement._id} elementActions={reglementElementActions} setElementAction={(a, e) => eval(a)(e)} />
                    }
                  </>
              }
            />
          }

        </Col>
      </Row>

    </Container>

  );
}

export default Reglements;